import { useAppSelector, useAppDispatch } from '../../../../../stores/hook'
import { useEffect, useMemo, useRef, useState } from 'react'
import { setSubscribeModalStatus } from '../../GetStartedSlice'

import styles from './SubscribeModal.module.scss'
import translations from '../../../../../text/get-started-translations.json';
import language from '../../../../../utils/LanguageSettings';
import { IPriceOption } from '../../../types';
import { BlocksContent } from "@strapi/blocks-react-renderer";
import { appendUtmParams } from '../../../../../utils/Url';
import { OTT, STB } from '../../../constants';
import ReactMarkdown from 'react-markdown';
import gfm from 'remark-gfm';
import rehypeRaw from "rehype-raw";
import React from 'react';
import closeImage from '../../../../../images/icon/icon-close.svg';
import { custTypeMapping } from '../../../../functions/filterCustomerTypeDisplay';
import { useLocation } from 'react-router-dom';

const SubscribeModal: React.FC<{ locale?: string }> = ({ locale }) => {
  
  // const pageTranslations = translations[language]; // Select the correct translations
  const isShow = useAppSelector((state) => state.getStarted.isShowSubscribeModal)
  const [isShowAlter, setIsShowAlter] = useState<boolean>(false);
  const packInfo = useAppSelector((state) => state.getStarted.packInfo)
  const isTvBoxPage = useAppSelector((state) => state.getStarted.isTvBoxPage)
  const isBoxPlan = useAppSelector((state) => state.getStarted.isBoxPlan)
  const isRecommendationPage = useAppSelector((state) => state.getStarted.isRecommendationPage)
  const link = window.myAppStrapi && window.myAppStrapi.phpButtonLink ? window.myAppStrapi.phpButtonLink : '';
  const campaignCodes = window.myAppStrapi && window.myAppStrapi.campaignCodeArray ? window.myAppStrapi.campaignCodeArray : {};
  const campaignCodeMap = new Map(Object.entries(campaignCodes));
  const dispatch = useAppDispatch();
  const listenerPlanRef = useRef(null);
  let custType = window.myAppStrapi && window.myAppStrapi.cust_type;
  let loginUrl = window.myAppStrapi && window.myAppStrapi.login_url;

   const location = useLocation();
   const isArticlePage = location.pathname.includes('/blog/');
   const langKey = (isArticlePage && locale) || language;
   const pageTranslations = translations[langKey as keyof typeof translations];

  useEffect(() => {
    if (isShow) {
      setIsShowAlter(true);
      document.getElementsByTagName("body")[0].classList.add("modal-open");
      document.getElementById("plan-modal-wrapper")?.classList.add("show");
    } else {
      document.getElementsByTagName("body")[0].classList.remove("modal-open");
      document.getElementById("plan-modal-wrapper")?.classList.remove("show");
    }
  }, [isShow])

  const filteredPriceOptions = useMemo(() => {
    return packInfo.PriceOptions
  }, [packInfo.PriceOptions, isTvBoxPage, isRecommendationPage])

  const onClickBtn = (e: React.MouseEvent<HTMLDivElement>, campaignCode: string) => {
    const isFromArticle = (packInfo as any).isFromArticle;
    const isOTT = (packInfo as any).isOTT;

    if (isFromArticle) {
      if (custType === '000' || custType === '001' || custType === '002' || custType === '004' || custType === 'r2stb') {
        window.location.href = '/subscriber-enquiry';
      } else {
        if (!isOTT) { // STB
          if (campaignCode) {
            if (campaignCodeMap.size > 0) {
              const cpm = campaignCodeMap.get(campaignCode);
              const d = new Date();
              d.setTime(d.getTime() + (30 * 24 * 60 * 60 * 1000));
              const expires = "expires=" + d.toUTCString();
              document.cookie = "cpm=" + cpm + ";" + expires + ";SameSite=None;Secure;domain=.nowtv.now.com;path=/";
              window.location.href = link+ '&lang=' + locale;
            }
          }
        } else { // OTT
          if (campaignCode) {
            const url = 'https://ssp.nowtv.now.com/choose-plan?campaign=' + campaignCode + '&lang=' + locale;
            window.location.href = appendUtmParams(url);
          }
        }
      }
    } else {
      if (custType === 'r2stb') {
        window.location.href = '/subscriber-enquiry';
      } else {
        if (isTvBoxPage || isRecommendationPage) {
          if (campaignCode) {
            if (campaignCodeMap.size > 0) {
              const cpm = campaignCodeMap.get(campaignCode);
              const d = new Date();
              d.setTime(d.getTime() + (30 * 24 * 60 * 60 * 1000));
              const expires = "expires=" + d.toUTCString();
              document.cookie = "cpm=" + cpm + ";" + expires + ";SameSite=None;Secure;domain=.nowtv.now.com;path=/";
              window.location.href = link;
            }
          }
        } else {
          if (campaignCode) {
            const url = 'https://ssp.nowtv.now.com/choose-plan?campaign=' + campaignCode + '&lang=' + language;
            window.location.href = appendUtmParams(url);
          }
        }
      }
    }
  }

  const renderSubscribeItems = () => {
    return (<div className={styles['plans-item-wrapper']}>
      {
        filteredPriceOptions.map((priceOption: IPriceOption, index: number) => (
          (
            <div key={priceOption.id} className={`${styles['item']} ${styles['plan-12-Month']}`}>
              <h4>
                {priceOption.PriceTitle}
                <p>{priceOption.PriceSubtitle}</p>
                </h4>
                <div className={`${styles.details}`}>
                  <div className={styles.offer}>
                      {
                        priceOption.Type === 'Yearly' && (
                          <div className={styles.price}>
                            { (isTvBoxPage || isRecommendationPage) ?
                              <><b>$ {(priceOption.Price / 12).toLocaleString('zh-HK')}</b> / {pageTranslations.mth}
                                <p>{pageTranslations["12MthsCommitment2"]}</p></> :
                              <><b>$ {priceOption.Price.toLocaleString('zh-HK')}</b> / {pageTranslations['12mth']}
                                <p>{pageTranslations.Avg} $ {(priceOption.Price / 12).toLocaleString('zh-Hk')} / {pageTranslations.mth}</p></>
                            }
                            {priceOption.Remark && typeof priceOption.Remark === 'string' && (
                              <div>
                                <ReactMarkdown remarkPlugins={[gfm]} rehypePlugins={[rehypeRaw]} components={{p: React.Fragment,}}>{priceOption.Remark}</ReactMarkdown>
                              </div>
                            )}
                          </div>
                        )
                      }
                      {
                        priceOption.Type === 'Monthly' && (
                          <div className={styles.price}>
                            <b>$ {priceOption.Price.toLocaleString('zh-HK')}</b> / { pageTranslations.Month}
                            { (!isTvBoxPage && !isRecommendationPage) ?<p>{pageTranslations.Cancel}</p> : <></>}
                            {priceOption.Remark && typeof priceOption.Remark === 'string' && (
                              <div>
                                <ReactMarkdown remarkPlugins={[gfm]} rehypePlugins={[rehypeRaw]} components={{p: React.Fragment,}}>{priceOption.Remark}</ReactMarkdown>
                              </div>
                            )}
                          </div>
                        )
                      }
                      {
                        priceOption.Type === 'Daily' && (
                          <div className={styles.price}>
                            <b>$ {priceOption.Price.toLocaleString('zh-HK')}</b> / { pageTranslations['day']}
                            {priceOption.Remark && typeof priceOption.Remark === 'string' && (
                              <div>
                                <ReactMarkdown remarkPlugins={[gfm]} rehypePlugins={[rehypeRaw]} components={{p: React.Fragment,}}>{priceOption.Remark}</ReactMarkdown>
                              </div>
                            )}
                          </div>
                        )
                      }
                      {
                        priceOption.Type === 'Event' && (
                          <div className={styles.price}>
                            <b>$ {priceOption.Price.toLocaleString('zh-HK')}</b> / { pageTranslations['EventPass']}
                            {priceOption.Remark && typeof priceOption.Remark === 'string' && (
                              <div>
                                <ReactMarkdown remarkPlugins={[gfm]} rehypePlugins={[rehypeRaw]} components={{p: React.Fragment,}}>{priceOption.Remark}</ReactMarkdown>
                              </div>
                            )}
                          </div>
                        )
                      }
                  </div>
                  { !isBoxPlan ? 
                  <div onClick={(e: React.MouseEvent<HTMLDivElement>) => {
                            onClickBtn(e, priceOption.Campaign);
                        }}
                        className={styles['button-control']}>
                    <span className={'btn primary'}>{pageTranslations.Select}</span>
                </div> : custTypeMapping[custType] == "User Type 1 (Not Logged In)" ? 
                <div onClick={() => {
                            window.location.href = loginUrl;
                        }}
                        className={styles['button-control']}>
                    <span className={'btn primary'}>{pageTranslations.Select}</span>
                </div> : <></>}
              </div>
            </div>
          )
        ))
      }
      <div className={styles["remarks"]}>
          {packInfo && packInfo.optionsContext && typeof packInfo.optionsContext === 'string' && (
            <div>
              <ReactMarkdown remarkPlugins={[gfm]} rehypePlugins={[rehypeRaw]}>{packInfo.optionsContext}</ReactMarkdown>
            </div>
          )}
      </div>
    </div>)
  }

  useEffect(() => {
      const handlePackLiener = (event: any) => {
        const targetDiv = document.getElementById('plan-alter-wrapper');
        if (targetDiv && !targetDiv.contains(event.target)) {
          onCloseClick();
        }
      };
  
      listenerPlanRef.current = handlePackLiener;
  
      if (isShowAlter) {
        document.addEventListener('click', handlePackLiener);
      } else {
        document.removeEventListener('click', handlePackLiener);
      }
  
      return () => {
        document.removeEventListener('click', listenerPlanRef.current);
      };
    }, [isShowAlter]);

  const onCloseClick = () => {
    setIsShowAlter(false);
    dispatch(setSubscribeModalStatus(false))
  }
  return (
    <div id='plan-modal-wrapper' className={`${styles['modal-wrapper']} modal-wrapper`} style={{display: isShow ? undefined : 'none'}}>
      <div className={styles['modal-dialog']}>
        <div className={`${styles['modal-content-wrapper']} ${styles['sm']}`}>
          <div className={styles['close-wrap']}>
            <div className={styles['close-btn']}>
              <button onClick={onCloseClick} className={`${styles['close-modal']} ${styles['close-Plans']}`}>
                {pageTranslations.Close}&nbsp;
                <img src={closeImage} alt="Close icon"></img>
                </button>
            </div>
          </div>
          <div id="plan-alter-wrapper" className={`${styles['alert-wrapper']} ${styles['commitment-free-wrapper']}`}>
            <h3>{packInfo.name}</h3>
            {renderSubscribeItems()}
          </div>
        </div>
      </div>
    </div>
)}

export default SubscribeModal